// extracted by mini-css-extract-plugin
export default {"container":"FooterLogoElement_container__Oaj2B","logoContainer":"FooterLogoElement_logoContainer__9KmP4","textRight":"FooterLogoElement_textRight__6O7oW"};